import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationAssessorDto {
    applicationId: number;
    appraiserId: number;
    appraiserName: string;
    division: string;
    crew: string;
    specialCase: string;
    stipPendingId: number;
    withPendingId: number;
    comments: string;
    complexCase: boolean;
    public create() {
        return {
            applicationId: 0,
            appraiserId: 0,
            appraiserName: '',
            division: '',
            crew: '',
            specialCase: '',
            stipPendingId: 0,
            withPendingId: 0,
            comments: '',
            complexCase: false
        
        }
    }
}